import React from "react";
import Thread from "../Thread/Thread";
import { Fab } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

const MobileSidebar = ({ open, onClose, onResetThread }) => {
    if (!open) return null;

    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 lg:hidden" onClick={onClose}>
            <div 
                className="bg-white w-64 h-full shadow-lg p-4" 
                onClick={(e) => e.stopPropagation()}
            >
                <div className="mb-4 text-right">
                    <Fab
                        size="small"
                        sx={{
                            width: 35, 
                            height: 35,
                            backgroundColor: "rgb(85, 94, 238)",
                            color: "#ffffff",
                            boxShadow: 'none',
                            '&:hover': {
                                backgroundColor: 'rgb(85, 94, 238)',
                                boxShadow: 'none',
                            },
                        }}
                        onClick={() => {
                            onResetThread();
                            onClose();
                        }}
                        >
                        <EditIcon />
                    </Fab>                                      
                </div>

                <Thread />
            </div>
        </div>
    );
};

export default MobileSidebar;
